import { computed, type Ref } from "vue";

import { config } from "@/config";
import { DictionariesHelper, RussianKeyboardHelper } from "@/helpers";
import { useSearchStore } from "@/stores";

export function useRussianKeyboard(query: Ref<string>, suggestionsOpen: Ref<boolean>) {
  const searchStore = useSearchStore();

  const isRussianSelected = computed<boolean>(
    () =>
      DictionariesHelper.RUSSIAN_DICTIONARY_IDS.includes(searchStore.selectedDictionaryId ?? "") ||
      [searchStore.filter?.sourceLanguage?.code, searchStore.filter?.targetLanguage?.code].includes("ru")
  );

  const showRussianKeyboard = computed<boolean>(() => isRussianSelected.value && !config.app.isMobile);

  const onRussianKeyboardKey = (key: RussianKeyboardHelper.Key) => {
    suggestionsOpen.value = true;

    if (key === "backspace") {
      query.value = query.value.slice(0, -1);
      return;
    }

    query.value = query.value + key;
  };

  return {
    showRussianKeyboard,
    onRussianKeyboardKey
  };
}
